import UploadsPageFilesUploadMinimizedModal from "@/components/uploads/modal/UploadsPageFilesUploadMinimizedModal";
import { AuthContext } from "@/data/auth/auth.context";

const BackgroundProfileUploads = () => {
  const { isLoggedIn } = AuthContext.useAuth();

  if (!isLoggedIn) {
    return null;
  }

  return <UploadsPageFilesUploadMinimizedModal />;
};

export default BackgroundProfileUploads;
